import Raven from "raven-js";
import { routerMiddleware } from "react-router-redux";
import browserHistory from "react-router/lib/browserHistory";
import thunkMiddleware from "redux-thunk";
import settings from "settings";
import prevPathMiddleware from "./prevPathMiddleware";
import ravenMiddleware from "./RavenMiddleware";

let middlewares = [routerMiddleware(browserHistory), thunkMiddleware, prevPathMiddleware];

if (process.env.NODE_ENV !== 'production') {
  // middlewares.push(createLogger());
}

if (process.env.NODE_ENV !== 'production') {
  // const { whyDidYouUpdate } = require('why-did-you-update')
  // whyDidYouUpdate(React)
  // whyDidYouUpdate(React, { include: [/^pure/], exclude: [/^Connect/] })
}

if (settings.sentryUrl) {
  Raven.config(settings.sentryUrl).install();
  middlewares = [...middlewares, ravenMiddleware];
}

export default middlewares;